__turbopack_context__.v({
  "dialogBackdrop": "Dialog-module__YgtddW__dialogBackdrop",
  "dialogCloseButton": "Dialog-module__YgtddW__dialogCloseButton",
  "dialogContent": "Dialog-module__YgtddW__dialogContent",
  "dialogPositioner": "Dialog-module__YgtddW__dialogPositioner",
});
